import React from "react";
import { Route, Switch,Redirect  } from "react-router-dom";
import Auth from "../pages/Auth";
import Dashboard from './../pages/Dashboard';
import DashboardTugas from './../pages/DashboardPetugas';
import DashboardPeminjam from './../pages/DashboardPeminjam';
import Peminjaman from "../pages/Pinjam/Peminjaman";
import PeminjamanWarkah from "../pages/Pinjam/PeminjamanWarkah";
import DaftarPeminjaman from "../pages/Pinjam/DaftarPinjam";
import DaftarKembali from "../pages/Pengembalian/ListKembali";
import Kembali from "../pages/Pengembalian/Pengembalian";
import Waiting from "../pages/Pinjam/WaitingList";
import TambahBT from "../pages/Pinjam/TambahBT";
import Akun from "../pages/Pinjam/Akun";
import Pencarian from "../pages/Pinjam/Pencarian";
// import History from "../pages/Pinjam/History";
import Riwayat from "../pages/Pinjam/RiwayatPinjam";
import LogPinjam from "../pages/Pinjam/LogPinjam";
import Petugas from "../pages/Pegawai/Petugas";
import Khusus from "../pages/BukuTanah/Khusus";
import LaporanBT from "../pages/Laporan/Laporan";
import Penolakan from "../pages/Penolakan/PenolakanBukuTanah";
import Ganti from "../pages/GantiKeperluan/Index";


const Routes = () => {

  const role = localStorage.getItem('role');

  const renderDashboard = () => {
    if (role === 'admin') {
      return <Dashboard />;
    } else if (role === 'peminjam') {
      return <DashboardPeminjam />;
    } else if (role === 'petugas' ||  role === 'tu') {
      return <DashboardTugas />;
    } else {
      return <Redirect to="/" />;
    }
  };

  return (
    <Switch>
      <Route exact path="/app/Auth" component={Auth} />
      <Route exact path="/app" render={renderDashboard} />
      {/* <Route exact path="/" component={Dashboard} /> */}
      <Route exact path="/app/dashboard" component={Dashboard} />
      <Route exact path="/app/dashboardpetugas" component={DashboardTugas} />
      <Route exact path="/app/dashboardpeminjam" component={DashboardPeminjam} />
      <Route exact path="/app/pinjam/peminjaman" component={Peminjaman} />
      <Route exact path="/app/pinjam/peminjamanWarkah" component={PeminjamanWarkah} />
      <Route exact path="/app/pinjam/daftarpinjam" component={DaftarPeminjaman} />
      <Route exact path="/app/pengembalian/listKembali" component={DaftarKembali} />
      <Route exact path="/app/pengembalian/pengembalian" component={Kembali} />
      <Route exact path="/app/pinjam/waitinglist" component={Waiting} />
      <Route exact path="/app/pinjam/tambahbt" component={TambahBT} />
      <Route exact path="/app/pinjam/pencarian" component={Pencarian} />
      {/* <Route exact path="/pinjam/history" component={History} /> */}
      <Route exact path="/app/pinjam/riwayat" component={Riwayat} />
      <Route exact path="/app/pinjam/logpinjam" component={LogPinjam} />
      <Route exact path="/app/pegawai/petugas" component={Petugas} />
      <Route exact path="/app/bukutanah/khusus" component={Khusus} />
      <Route exact path="/app/penolakan/penolakan" component={Penolakan} />
      <Route exact path="/app/gantikeperluan" component={Ganti} />
      <Route exact path="/app/laporan/laporan" component={LaporanBT} />
      <Route exact path="/app/akun" component={Akun} />

    </Switch>
  );
};

export default Routes;
